import { observer } from 'mobx-react';
import * as React from 'react';
import { EntityStoreLifecycle } from './EntityStoreLifecycle';
import { IdleLifecycle } from './IdleLifecycle';
import { LocationStoreLifecycle } from './LocationStoreLifecycle';
import { PublicEnumInfoLifecycle } from './PublicEnumInfoLifecycle';
import { ReoctoLifecycle } from './ReoctoLifecycle';

@observer export class Lifecycle extends React.Component {
	render() {
		return <React.Fragment>
			<ReoctoLifecycle/>
			<EntityStoreLifecycle/>
			<LocationStoreLifecycle/>
			<PublicEnumInfoLifecycle/>
			<IdleLifecycle/>
		</React.Fragment>;
	}
}
